import React from 'react';

const Input = ({
  id,
  type = 'text',
  required = false,
  className = '',
  placeholder,
  value,
  onChange,
  label,
  error
}) => {
  const baseClasses = 'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500';
  const errorClasses = error ? 'border-red-500' : '';
  const inputClasses = `${baseClasses} ${errorClasses} ${className}`;

  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={id} className="block mb-2 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        id={id}
        type={type}
        required={required}
        className={inputClasses}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default Input;

